import React, { useEffect, useState, useRef } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";

const LiveMap = ({ lastLocation, liveTracking = false }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyDhRQaWrORz1dr4-nWgDA7f74qwx_5gHBk",
  });

  const [currentLocation, setCurrentLocation] = useState(lastLocation);
  const mapRef = useRef(null);

  useEffect(() => {
    if (!liveTracking) return;

    if (!navigator.geolocation) {
      alert("Geolocation not supported");
      return;
    }

    const watchId = navigator.geolocation.watchPosition(
      (position) => {
        const newLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };

        setCurrentLocation(newLocation);

        if (mapRef.current) {
          mapRef.current.panTo(newLocation);
        }
      },
      (error) => console.error(error),
      {
        enableHighAccuracy: true,
        maximumAge: 0,
        timeout: 5000,
      }
    );

    return () => navigator.geolocation.clearWatch(watchId);
  }, [liveTracking]);

  if (!isLoaded) return <div>Loading...</div>;

  return (
    <GoogleMap
      mapContainerStyle={{ width: "100%", height: "400px" }}
      center={currentLocation}
      zoom={15}
      onLoad={(map) => (mapRef.current = map)}
    >
      <Marker position={currentLocation} />
    </GoogleMap>
  );
};

export default LiveMap;